import {createContext} from "react";
import {FilesProvider} from "./FileProvider";

export const AppContextInitialState = {
  filesContext: new FilesProvider(),
};

export const AppContext = createContext(AppContextInitialState);
